module.exports = __webpack_public_path__ + "static/media/other-pension.de608e65.svg";